import { useMemo } from "react";

import { grey } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { sanitizeHTML } from "utils/common";

const sx = {
  fontSize: "105%",
  lineHeight: "1.6",
  "&": {
    table: { border: `solid 1px ${grey[400]}`, borderCollapse: "collapse" },
    th: { border: `solid 1px ${grey[400]}`, p: 1 },
    td: { border: `solid 1px ${grey[400]}`, p: 1 },
    li: { mt: 0.5 },
  },
};

type MarkdownContainerProps = {
  children: any;
  html?: boolean;
};

export default function MarkdownContainer({
  children,
  html = false,
}: Readonly<MarkdownContainerProps>) {
  // Memoize so we don't re-parse HTML on every parent re-render. Scribe SOAP
  // notes can be multi-KB; running DOMParser per render shows up in profiles.
  const sanitized = useMemo(
    () => sanitizeHTML(typeof children === "string" ? children : ""),
    [children]
  );

  if (html) {
    return (
      <Typography
        component="div"
        sx={sx}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    );
  }
  return (
    <Typography component="div" sx={sx}>
      <Markdown remarkPlugins={[remarkGfm]}>{children}</Markdown>
    </Typography>
  );
}
